/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1TimeframePreset } from '../models/V1TimeframePreset';
import { HttpFile } from '../http/http';

/**
* Timeframe defines the date range of data included in a report. When preset is TIMEFRAME_PRESET_CUSTOM, start and end are required and end must be on or after start. Otherwise start and end are ignored.
*/
export class Orgmanagerv1Timeframe {
    'preset'?: V1TimeframePreset;
    /**
    * Lower bound (inclusive). If this field is empty, then the start time of the earliest campaign or order line included in the report is used as the lower bound.
    */
    'start'?: Date;
    /**
    * Upper bound (inclusive). If this field is empty, then the current time is used as the upper bound.
    */
    'end'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "preset",
            "baseName": "preset",
            "type": "V1TimeframePreset",
            "format": ""
        },
        {
            "name": "start",
            "baseName": "start",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "end",
            "baseName": "end",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return Orgmanagerv1Timeframe.attributeTypeMap;
    }

    public constructor() {
    }
}

